import styled from 'styled-components';

export const StyledSummaryContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 16px;
  margin-top: 24px;
  margin-left: 24px;
  margin-right: 8px;
`;

export const StyledSummaryDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 8px;
  flex: 1;
  width: 100%;

  & > h1 {
    margin-bottom: 0;
  }
`;

export const StyledSummaryToolsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 8px;
`;
